module.exports = __webpack_public_path__ + "static/media/language-selected.fa349099.svg";